<template>
  <div style="margin-bottom: 0.75rem">
    <template v-if="customField.type === ENUMS.CustomFieldTypeEnum.Text.value">
      <form-field-input
          :label="customField.label"
          v-bind="$attrs"
          :value="value"
          :validation-errors="validationError"
          @input="handleInput"
      ></form-field-input>
    </template>

    <template v-if="customField.type === ENUMS.CustomFieldTypeEnum.Number.value">
      <form-field-input
          type="number"
          :label="customField.label"
          v-bind="$attrs"
          :value="value"
          :validation-errors="validationError"
          @input="handleInput"
      ></form-field-input>
    </template>

    <template v-if="customField.type === ENUMS.CustomFieldTypeEnum.Date.value">
      <form-field-date-picker
          :label="customField.label"
          v-bind="$attrs"
          :value="value"
          :validation-errors="validationError"
          @input="handleInput"
          has-clear-button
      ></form-field-date-picker>
    </template>

    <template v-if="customField.type === ENUMS.CustomFieldTypeEnum.Time.value">
      <form-field-time-picker
          type="time"
          :label="customField.label"
          v-bind="$attrs"
          :value="value"
          :validation-errors="validationError"
          @input="handleInput"
      ></form-field-time-picker>
    </template>

    <template v-if="customField.type === ENUMS.CustomFieldTypeEnum.DropDown.value">
      <form-field-select
          :label="customField.label"
          v-bind="$attrs"
          :value="value"
          :validation-errors="validationError"
          @input="handleInput"
      >
        <option v-if="isValueNotInOptions" disabled="">{{ value }}</option>
        <option v-for="option in customField.options" :value="option">{{option}}</option>
      </form-field-select>
    </template>

    <template v-if="customField.type === ENUMS.CustomFieldTypeEnum.Url.value">
      <form-field-input
          :label="customField.label"
          v-bind="$attrs"
          :value="value"
          :validation-errors="validationError"
          @input="handleInput"
          help-text="please include https:// or http:// in the url."
      ></form-field-input>
    </template>

    <template v-if="customField.type === ENUMS.CustomFieldTypeEnum.TextArea.value">
      <form-field-textarea
          :label="customField.label"
          v-bind="$attrs"
          :value="value"
          :validation-errors="validationError"
          @input="handleInput"
      ></form-field-textarea>
    </template>

    <template v-if="customField.type === ENUMS.CustomFieldTypeEnum.Phone.value">
      <form-field-input
          type="tel"
          :label="customField.label"
          v-bind="$attrs"
          :value="value"
          :validation-errors="validationError"
          @input="handleInput"
      ></form-field-input>
    </template>

    <template v-if="customField.type === ENUMS.CustomFieldTypeEnum.Email.value">
      <form-field-input
          type="email"
          :label="customField.label"
          v-bind="$attrs"
          :value="value"
          :validation-errors="validationError"
          @input="handleInput"
      ></form-field-input>
    </template>

    <template v-if="customField.type === ENUMS.CustomFieldTypeEnum.Currency.value">
      <form-field-currency
          :label="customField.label"
          v-bind="$attrs"
          :value="value"
          :validation-errors="validationError"
          @input="handleInput"
      ></form-field-currency>
    </template>
  </div>
</template>

<script>
  import FormField from "./FormField";
  import {FormFieldMixin} from "./FormField.mixin";

  export default {
    name: "FormFieldCustomField",
    components: {FormField},
    mixins: [FormFieldMixin],
    props: {
      value: {},
      customFieldId: {
        required: true,
      },
      validationError: {
        type: String
      }
    },
    data() {
      return {
        forId: this.inputId ? this.inputId : this.$utils.generateClientId(),
      }
    },
    computed: {
      customField() {
        return this.$store.getters.customFieldsWithTrashed.find(customField => customField.id === this.customFieldId);
      },
      isValueNotInOptions() {
        return ! this.customField.options.includes(this.value);
      },
    },
    methods: {
      handleInput(val) {
        this.$emit('input', val);
        this.$emit('change', val);

        this.emitGlobalFieldChangeEvent();
      },
    }
  }
</script>

<style lang="scss" scoped>
// Due to how Buefy works these styles must be in global styles
</style>
